export const ABHA_HERO_WIDGET_DEFAULT_DATA = {
  IMAGE_SRC: 'https://acko-cms.ackoassets.com/ABHA_Widget_BG_9607340c25.webp',
  CTA_TEXT: 'Create my ABHA card',
  ALREADY_HAVE_ABHA_TEXT: 'Already have an ABHA card?',
}

export const ABHA_HOW_TO_SECTION_IMAGE = 'https://acko-cms.ackoassets.com/How_to_Section_Image_124be4613c.webp'

export const ABHA_HERO_WIDGET_SECONDARY_ARROW_ICON = 'https://acko-cms.ackoassets.com/Icon_Right_d5d363cef2.svg'
export const ABHA_HERO_EXISTING_ABHA_LOCK_ICON = 'https://acko-cms.ackoassets.com/Lock_8c39804bb1.svg'

export const ABHA_HERO_DEFAULT_DISCLAIMER =
  "By continuing you agree to ACKO's terms and privacy policy. ABHA card creation is 100% free, powered by NHA."

/** Figma hero background — brand subtle fill */
export const ABHA_HERO_BACKGROUND = 'var(--Surface-accent-Violet-50, #F5F3FF)'

/** Figma how-to section — steps panel / section surface */
export const ABHA_HOW_TO_SECTION_BACKGROUND = 'var(--surfaceBase)'

/** Figma how-to image panel background */
export const ABHA_HOW_TO_IMAGE_BACKGROUND = 'var(--brandSubtle)'

/** Figma step number color — purple on mobile, blue on desktop */
export const ABHA_STEP_NUMBER_COLOR = 'var(--fillBrand)'
export const ABHA_STEP_NUMBER_COLOR_DESKTOP = 'var(--accentBlueContent)'

/** Figma mobile badge accent */
export const ABHA_HERO_BADGE_ACCENT = 'var(--accentOrange)'

/** Figma AbhaHeroWidget — form fade from image to white */
export const ABHA_HERO_WIDGET_FORM_GRADIENT = 'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 1.99%, #FFF 24%)'

/** Figma AbhaHeroWidget card shadow (mobile + desktop) */
export const ABHA_HERO_WIDGET_BOX_SHADOW =
  '0 20px 20px -3px rgba(0, 0, 0, 0.02), 0 6px 6px -2px rgba(0, 0, 0, 0.02), 0 3.5px 3.5px -1.5px rgba(0, 0, 0, 0.02), 0 2px 4px -1px rgba(0, 0, 0, 0.02), 0 0.8px 0.8px -0.5px rgba(0, 0, 0, 0.02), 1px 1px 2px 0 #FFF inset, -1px -1px 2px 0 rgba(0, 0, 0, 0.04) inset, -0.5px -0.5px 0 -1px rgba(0, 0, 0, 0.00) inset'

/** Desktop card width from Figma node 595-2377 */
export const ABHA_HERO_WIDGET_DESKTOP_WIDTH = 520

/** Figma AbhaHeroWidget phone validation error (node 595-2368) */
export const ABHA_HERO_PHONE_ERROR_MESSAGE = 'Enter a valid phone number to proceed'

export const ABHA_HERO_PHONE_MAX_LENGTH = 10

export const ABHA_HERO_AADHAAR_ERROR_MESSAGE = 'Enter a valid Aadhaar number'

export const ABHA_HERO_OTP_ERROR_MESSAGE = 'Please enter a valid 6-digit OTP'

export const ABHA_HERO_AADHAAR_VERIFICATION_DELAY_ERROR_MESSAGE =
  'Aadhaar verification is taking longer than expected. Try again in a while.'

export const ABHA_HERO_MODAL_CLOSE_ICON = 'https://acko-cms.ackoassets.com/Close_cross_34da11e2b9.svg'

/** Figma modal — Aadhaar step (1657-1907) */
export const ABHA_HERO_MODAL_AADHAAR_STEP_DATA = {
  TITLE: 'Enter your details',
  DESCRIPTION: "We'll use this to verify your identity and create your ABHA card",
  LABEL: 'Aadhaar number',
  PLACEHOLDER: 'XXXX XXXX XXXX',
  HELPER: 'Your 12-digit Aadhaar number',
  PHONE_LABEL: 'Phone number for ABHA communication',
  PHONE_PLACEHOLDER: 'Mobile number',
  CONSENT_TEXT:
    'I, hereby declare that\nI am voluntarily sharing my Aadhaar Number / Virtual ID issued by the Unique Identification Authority of India ("UIDAI"), and my demographic information for the purpose of creating an Ayushman Bharat Health Account number ("ABHA number") and Ayushman Bharat Health Account address ("ABHA Address"). I authorize NHA to use my Aadhaar number / Virtual ID for performing Aadhaar based authentication with UIDAI as per the provisions of the Aadhaar (Targeted Delivery of Financial and other Subsidies, Benefits and Services) Act, 2016 for the aforesaid purpose. I understand that UIDAI will share my e-KYC details, or response of "Yes" with NHA upon successful authentication. I intend to create Ayushman Bharat Health Account Number and Ayushman Bharat Health Account address using document other than Aadhaar.',
  DISCLAIMER_TEXT: 'Your Aadhaar details are encrypted and never stored.',
  DISCLAIMER_ICON_SRC: 'https://acko-cms.ackoassets.com/Coverage_92eb328c08.svg',
  CTA_TEXT: 'Send OTP',
}

export const ABHA_HERO_EXISTING_ABHA_PHONE_STEP_DATA = {
  TITLE: 'Enter mobile number linked to your ABHA',
  DESCRIPTION: "We'll use this to fetch your ABHA card",
  MOBILE_DESCRIPTION: "We'll use this to verify and fetch your ABHA card",
  INPUT_LABEL: 'Phone number linked to ABHA',
  PLACEHOLDER: 'Enter your phone number',
  MOBILE_PLACEHOLDER: 'Mobile number',
  CTA_TEXT: 'Fetch ABHA',
  MOBILE_CTA_TEXT: 'Send OTP',
  DISCLAIMER_TEXT: 'ACKO is an official ABHA partner trusted by 8 million Indians',
  MOBILE_DISCLAIMER_TEXT: 'Your Aadhaar details are encrypted and never stored.',
  DISCLAIMER_ICON_SRC: 'https://acko-cms.ackoassets.com/Coverage_92eb328c08.svg',
}

export const ABHA_HERO_EXISTING_ABHA_PREPARE_STEP_DATA = {
  IMAGE_SRC: 'https://acko-cms.ackoassets.com/Health_Card_252e6d35af.webp',
  TITLE: 'Looking for your ABHA card...',
}

export const ABHA_HERO_EXISTING_ABHA_SUCCESS_STEP_DATA = {
  TITLE: 'Here are the ABHA cards linked to your number',
  DESCRIPTION: "We'll send an OTP to {{phone_number}} to verify your identity before download.",
  MOBILE_TITLE: 'Here are the ABHA cards linked to your number',
  VIEW_CTA_TEXT: 'View ABHA',
  DOWNLOAD_CTA_TEXT: 'Download ABHA card',
}

export const ABHA_HERO_EXISTING_ABHA_EMPTY_STEP_DATA = {
  TITLE: "We couldn't find any ABHA card on your mobile number",
  PRIMARY_CTA_TEXT: 'Try with a different number',
  SECONDARY_CTA_TEXT: 'Create new ABHA',
  IMAGE_SRC: 'https://acko-cms.ackoassets.com/Unable_to_process_bf32084a1a.webp',
}

export const ABHA_HERO_EXISTING_ABHA_OTP_STEP_DATA = {
  TITLE: 'Verify your ABHA linked number',
  DESCRIPTION: '6-digit OTP was sent to {{masked_phone_number}}',
  OTP_LABEL: 'Enter OTP',
  CTA_TEXT: 'Verify now',
}

export const ABHA_HERO_EXISTING_ABHA_MALE_AVATAR = 'https://acko-cms.ackoassets.com/Male_selected_fbe0e3b9cd.webp'
export const ABHA_HERO_EXISTING_ABHA_FEMALE_AVATAR = 'https://acko-cms.ackoassets.com/Female_selected_5ae8107c10.webp'

export const TRUST_BADGE_LOGO = {
  imageSrc: 'https://acko-cms.ackoassets.com/NHA_Hero_Image_997ea05c9f.webp',
  alt: 'NHA Logo',
  width: 332,
  height: 144,
}

export const ABHA_HERO_MODAL_CONSENT_CHECKBOX_LABEL = 'I agree to the above declaration'

/** Figma modal — Aadhaar step disclaimer (285-1918) */
export const ABHA_HERO_MODAL_AADHAAR_DISCLAIMER = 'Your Aadhaar details are encrypted and never stored.'
export const ABHA_HERO_MODAL_DISCLAIMER_ICON = 'https://acko-cms.ackoassets.com/Coverage_92eb328c08.svg'

/** Figma modal — prepare step (285-2817) */
export const ABHA_HERO_MODAL_PREPARE_STEP_DATA = {
  IMAGE_SRC: 'https://acko-cms.ackoassets.com/Health_Card_252e6d35af.webp',
  TITLE: 'Preparing your ABHA card...',
}
export const ABHA_HERO_MODAL_PREPARE_DURATION_MS = 3000

/** CMS template variable for OTP step masked phone substitution */
export const ABHA_HERO_MASKED_PHONE_TEMPLATE_VAR = '{{masked_phone_number}}'
export const ABHA_HERO_PHONE_TEMPLATE_VAR = '{{phone_number}}'

/** Figma modal — OTP step (285-2362 / 407-1792) */
export const ABHA_HERO_MODAL_OTP_STEP_DATA = {
  TITLE: 'Verify Aadhaar',
  DESCRIPTION: `6-digit OTP was sent to your Aadhaar-linked number (${ABHA_HERO_MASKED_PHONE_TEMPLATE_VAR})`,
  OTP_LABEL: 'OTP',
  CTA_TEXT: 'Verify and create ABHA',
}

/** Figma modal — mobile OTP step (1433-1797 / 1716-3012) */
export const ABHA_HERO_MODAL_MOBILE_OTP_STEP_DATA = {
  TITLE: 'Verify your mobile number',
  DESCRIPTION: `Your Aadhaar is verified. The mobile number you entered (${ABHA_HERO_PHONE_TEMPLATE_VAR}) is not linked to your Aadhaar.\n\nWe've sent an OTP to this number to verify it.`,
  OTP_LABEL: 'Enter OTP',
  CTA_TEXT: 'Verify and create ABHA',
}

export const ABHA_HERO_MODAL_RESEND_OTP = 'Resend OTP'
export const ABHA_HERO_MODAL_RESEND_OTP_COUNTDOWN_LABEL = 'Resend OTP in'
export const ABHA_HERO_MODAL_RESEND_OTP_SECONDS = 30

/** Figma modal — OTP step disclaimer (847-1887) */
export const ABHA_HERO_MODAL_OTP_DISCLAIMER = ABHA_HERO_MODAL_AADHAAR_DISCLAIMER

/** Figma success modal — desktop 337-2606 / mobile 569-16606 */
export const ABHA_HERO_SUCCESS_REVEAL_DURATION_MS = 2000
export const ABHA_HERO_CARD_REVEAL_RESIDUE_IMAGE = 'https://acko-cms.ackoassets.com/animation_residue_2_2fabb3bdd5.webp'
export const ABHA_HERO_SUCCESS_CARD_PLACEHOLDER_AVATAR =
  'https://acko-cms.ackoassets.com/Profile_Container_14205e5a28.webp'
export const DEFAULT_ABHA_CARD_PREVIEW = {
  name: 'Prateik Binder',
  dateOfBirth: '18 Jan 1994',
  maskedAbhaNumber: '** _ **** _ **** _ ****',
  abhaNumber: '12 - 3456 - 7891 - 2345',
  abhaAddress: 'prateik54330870@abdm',
  profileImageUrl: ABHA_HERO_SUCCESS_CARD_PLACEHOLDER_AVATAR,
  relationshipLabel: 'You',
}
export const ABHA_HERO_SUCCESS_BADGE_MOBILE = 'Your ABHA card is ready!'
export const ABHA_HERO_SUCCESS_BADGE_DESKTOP = 'Your card is ready!'
export const ABHA_HERO_SUCCESS_TITLE_DESKTOP = 'Get your ABHA card on the ACKO app'
export const ABHA_HERO_SUCCESS_TITLE_MOBILE = 'Find it on the ACKO app. Download now.'
export const ABHA_HERO_SUCCESS_QR_TITLE = 'Scan to download'
export const ABHA_HERO_SUCCESS_QR_SUBTITLE = 'Available on iOS and Android'
export const ABHA_HERO_SUCCESS_TRUST_TEXT = 'Trusted by over 8 crore Indians'
export const ABHA_HERO_SUCCESS_FEATURE_MANAGE = 'View and manage\nyour ABHA card'
export const ABHA_HERO_SUCCESS_FEATURE_FAMILY = 'Create ABHA\nfor your family'
export const ABHA_HERO_SUCCESS_DOWNLOAD_CTA = 'Download the ACKO app'
export const ABHA_HERO_SUCCESS_DOWNLOAD_ABHA_CTA = 'Download ABHA card'
export const ABHA_HERO_SUCCESS_DOWNLOAD_ABHA_CTA_MOBILE = 'Download ABHA'
export const ABHA_HERO_SUCCESS_CREATE_ANOTHER_CARD_CTA = 'Create another card'
export const ABHA_HERO_SUCCESS_SHOW_BADGE = 'Your ABHA card is ready!'
export const ABHA_HERO_SUCCESS_SHOW_TITLE_MOBILE = 'Your ABHA card is ready for download'
export const ABHA_HERO_SUCCESS_SHOW_THEMED_TITLE_MOBILE = 'Be emergency-ready with ACKO'
export const ABHA_HERO_SUCCESS_SHOW_THEMED_DESCRIPTION_MOBILE =
  'Find everything your family needs to stay emergency-ready on the ACKO app'
export const ABHA_HERO_SUCCESS_APP_LINK = 'https://ackoapp.onelink.me/fGNi/45br3h3h'
export const ABHA_HERO_SUCCESS_FEATURE_MANAGE_ICON = 'https://acko-cms.ackoassets.com/Profile_Container_14205e5a28.webp'
export const ABHA_HERO_SUCCESS_FEATURE_FAMILY_ICON = 'https://acko-cms.ackoassets.com/Counter_68e4666f2a.webp'
export const ABHA_HERO_SUCCESS_BADGE_ICON = 'https://acko-cms.ackoassets.com/Tick_15b309a922.webp'
export const ABHA_HERO_SUCCESS_MOBILE_BACKGROUND =
  'linear-gradient(180deg, #0b0612 0%, #1a0b2e 35%, #4a1d96 72%, #6b2bd9 100%)'
